import { render, staticRenderFns } from "./AppSumoRegister.vue?vue&type=template&id=5bccf704&scoped=true"
import script from "./AppSumoRegister.vue?vue&type=script&lang=js"
export * from "./AppSumoRegister.vue?vue&type=script&lang=js"
import style0 from "./AppSumoRegister.vue?vue&type=style&index=0&id=5bccf704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bccf704",
  null
  
)

export default component.exports